export default function UkRailSearchFormBaseController(
    $scope,
    $state,
    $stateParams,
    $timeout,
    railsUtils,
    railsFactory,
    settingsAirlines,
    l10nService,
    timeSlots,
    timeService,
    userService,
    staticData,
    ukrailCardsService,
    authService,
) {
    'ngInject';

    let staticMinutesOptionsList;

    init();

    const {dateFormat} = userService.getRegionalSettings();
    const _Adult = railsFactory.params.Travelers.Adult.value;

    function init() {
            Object.assign($scope, {
            module: railsFactory.getModule(),
            isFlights: railsFactory.isFlights(),
            isTrains: railsFactory.isTrains(),
            isUkRail: railsFactory.isUkRail(),
            $state,
            params: railsFactory.params,
            options: railsFactory.options,
            isAmendmentMode,
        });
        $scope.options.time = railsFactory.getTimeOptions(timeSlots);
        $scope.params.Travelers.Child = 0;
        $scope.options.airlines = settingsAirlines;
        $scope.options.adults = railsUtils.makeTravellersOptions('Adult', 4, false);
        $scope.options.infants = railsUtils.makeTravellersOptions('Infant', _Adult, true);
        $scope.options.children = railsUtils.makeTravellersOptions('Child', 4 - _Adult, true);
        $scope.StaticDataList = staticData;
        $scope.StaticDataList.GoVias.splice(0, 0, {Text: 'None', Value: ''});
        $scope.options.ukRailTimeHoursOptions = $scope.StaticDataList.Hours;
        $scope.options.ukRailTimeMinutesOptions = $scope.StaticDataList.Minutes;
        staticMinutesOptionsList = angular.fromJson(angular.toJson($scope.options.ukRailTimeMinutesOptions));
        $scope.options.ukRailGoViaAvoidOptions = _.map($scope.StaticDataList.GoVias, (item) => ({Text: l10nService.localize(item.Text), Value: item.Value}));
        if (!$scope.params.GoViaOrAvoid) {
            $scope.params.GoViaOrAvoid = $scope.options.ukRailGoViaAvoidOptions[0];
        }

        if ($scope.isUkRail) {
            const maxTravellerCount = authService.getAvailableServicesFromSessionStorage().MaxTravelerAmount;
            $scope.options.adults = railsUtils.makeTravellersOptions('Adult', maxTravellerCount ? Math.min(8, maxTravellerCount) : 8, false);
            $scope.options.children = railsUtils.makeTravellersOptions('Child', 7 - _Adult, true);
        }

        if (isAmendmentMode()) {
            prePopulateSearchForm();
        } else {
            setNextDepartureTraintime();
            setNextReturnTraintime();
        }

        getRailCards();
        getFrequentRails();
    }

    function resetHourAndMinuteErrors(ctrl) {
        ctrl.railsSearch.RoundTripReturnHour.$error.invalidHour = false;
        ctrl.railsSearch.RoundTripReturnMinutes.$error.invalidMinute = false;
        ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', true);
        ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinute', true);
    }

    function prePopulateSearchForm() {
        const {departure, arrival, travellersCount} = $stateParams.rebook;
        const [railTicketSearchSegment] = $scope.params.RailTicketSearchSegments;
        if (railTicketSearchSegment) {
            setSelectedFrequentRail(railTicketSearchSegment, '_departure')(departure);
            setSelectedFrequentRail(railTicketSearchSegment, '_arrival')(arrival);
            railTicketSearchSegment._date = moment(departure.date, dateFormat);
            const hours = railTicketSearchSegment._date.hours();
            const minutes = railTicketSearchSegment._date.minutes();
            railTicketSearchSegment.DMinutes = timeService.getSelectedMinutesOption(staticMinutesOptionsList, minutes);
            railTicketSearchSegment.DHour = getHoursOption(hours, minutes);
        }
        const {adults = []} = $scope.options;
        [$scope.params.Travelers.Adult] = adults.filter((item) => parseInt(item.value, 10) === travellersCount) || adults;
    }

    function getHoursOption(hours, minutes) {
        return minutes > 45
            ? {Text: railsUtils.convertHoursToString(hours + 1), Value: hours + 1}
            : {Text: railsUtils.convertHoursToString(hours), Value: hours};
    }

    function isAmendmentMode() {
        return !!$stateParams.rebook;
    }

    $scope.options.time0 = angular.copy($scope.options.time);
    $scope.options.time1 = angular.copy($scope.options.time);
    $scope.options.time2 = angular.copy($scope.options.time);
    $scope.options.time3 = angular.copy($scope.options.time);

    $scope.frequentRails = [];

    $scope.getFrequentFlightView = getFrequentFlightView;
    $scope.setSelectedFrequentRail = setSelectedFrequentRail;

    /* Station Validations*/
    $scope.validateFromToStations = function(ctrl, controlName) { // eslint-disable-line
        if (controlName === '_address1') {
            ctrl.railsSearch._address1.$error.InvalidToStation = false;
            ctrl.railsSearch._address1.$setValidity('InvalidToStation', true);
            ctrl.railsSearch.$valid = true;

            const {
                _departure: {Code: departureCode} = {},
                _arrival: {Code: arrivalCode} = {},
            } = $scope.params.RailTicketSearchSegments[0];

            if (departureCode === arrivalCode) {
                ctrl.railsSearch._address1.$error.InvalidToStation = true;
                ctrl.railsSearch._address1.$setValidity('InvalidToStation', false);
                ctrl.railsSearch.$valid = false;
            }
            if ($scope.params.GoViaOrAvoidRailStation) {
                if ($scope.params.RailTicketSearchSegments[0]._departure.Code === $scope.params.GoViaOrAvoidRailStation.Code
                    || $scope.params.RailTicketSearchSegments[0]._arrival.Code === $scope.params.GoViaOrAvoidRailStation.Code) {
                    ctrl.railsSearch._address1.$error.InvalidToStation = true;
                    ctrl.railsSearch._address1.$setValidity('InvalidToStation', false);
                    ctrl.railsSearch.$valid = false;
                }
            }
        } else if (controlName === '_address02') {
            ctrl.railsSearch._address02.$error.InvalidToStation = false;
            ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            ctrl.railsSearch.$valid = true;
            //ctrl.railsSearch._address02.$setValidity('InvalidToStation', true);
            if ($scope.params.RailTicketSearchSegments[0]._departure && $scope.params.RailTicketSearchSegments[0]._arrival && $scope.params.RailTicketSearchSegments[0]._departure.Code === $scope.params.RailTicketSearchSegments[0]._arrival.Code) {
                ctrl.railsSearch._address02.$error.InvalidToStation = true;
                ctrl.railsSearch._address02.$setValidity('InvalidToStation', false);
                ctrl.railsSearch.$valid = false;
            }
            if (angular.isDefined($scope.params.GoViaOrAvoidRailStation)) {
                if ($scope.params.RailTicketSearchSegments[0]._departure && $scope.params.RailTicketSearchSegments[0]._departure.Code === $scope.params.GoViaOrAvoidRailStation.Code
                    || $scope.params.RailTicketSearchSegments[0]._arrival && $scope.params.RailTicketSearchSegments[0]._arrival.Code === $scope.params.GoViaOrAvoidRailStation.Code) {
                    ctrl.railsSearch._address02.$error.InvalidToStation = true;
                    ctrl.railsSearch._address02.$setValidity('InvalidToStation', false);
                    ctrl.railsSearch.$valid = false;
                }
            }
        }
        return ctrl.railsSearch.$valid;
    };

    $scope.validateDepartureDateTime = function(ctrl, formType) { // eslint-disable-line
        const ukdatetime = getCurrentUKDateTime();

        const currentDate = Date.parse(moment(moment(ukdatetime).format('DD/MM/YYYY'), 'DD/MM/YYYY'));
        const CurrentHours = moment(ukdatetime).format('HH:mm');
        const departureDate = Date.parse(moment($scope.params.RailTicketSearchSegments[0]._date, 'DD/MM/YYYY'));//Date.parse(moment($scope.params.RailTicketSearchSegments[0]._date, 'DD/MM/YYYY'));
        const CurrentTime = CurrentHours.split(':');

        if (formType === 'roundtrip') {
            ctrl.railsSearch.$valid = true;
            ctrl.railsSearch.RoundTripDepartureHour.$error.invalidHour = false;
            ctrl.railsSearch.RoundTripDepartureMinutes.$error.invalidMinute = false;
            ctrl.railsSearch.RoundTripDepartureHour.$setValidity('invalidHour', true);
            ctrl.railsSearch.RoundTripDepartureMinutes.$setValidity('invalidMinute', true);
            if (departureDate < currentDate) {
                ctrl.railsSearch.$valid = false;
                return false;
            } else if ((departureDate === currentDate)
                && parseInt($scope.params.RailTicketSearchSegments[0].DHour.Value, 10) < parseInt(CurrentTime[0], 10)) {
                ctrl.railsSearch.RoundTripDepartureHour.$error.invalidHour = true;
                ctrl.railsSearch.$valid = false;
                ctrl.railsSearch.RoundTripDepartureHour.$setValidity('invalidHour', false);
                return false;
            } else if ((departureDate === currentDate)
                && (parseInt($scope.params.RailTicketSearchSegments[0].DHour.Value, 10) === parseInt(CurrentTime[0], 10))
                && parseInt($scope.params.RailTicketSearchSegments[0].DMinutes.Value, 10) < parseInt(CurrentTime[1], 10)) {
                ctrl.railsSearch.RoundTripDepartureMinutes.$error.invalidMinute = true;
                ctrl.railsSearch.$valid = false;
                ctrl.railsSearch.RoundTripDepartureMinutes.$setValidity('invalidMinute', false);
                return false;
            }
            return true;
        } else if (formType === 'oneway') {
            ctrl.railsSearch.$valid = true;
            ctrl.railsSearch.OneWayDepartureHour.$error.invalidHour = false;
            ctrl.railsSearch.OneWayDepartureMinutes.$error.invalidMinute = false;
            ctrl.railsSearch.OneWayDepartureHour.$setValidity('invalidHour', true);
            ctrl.railsSearch.OneWayDepartureMinutes.$setValidity('invalidMinute', true);
            if (departureDate < currentDate) {
                ctrl.railsSearch.$valid = false;
                return false;
            } else if ((departureDate === currentDate)
                && parseInt($scope.params.RailTicketSearchSegments[0].DHour.Value, 10) < parseInt(CurrentTime[0], 10)) {
                ctrl.railsSearch.OneWayDepartureHour.$error.invalidHour = true;
                ctrl.railsSearch.$valid = false;
                ctrl.railsSearch.OneWayDepartureHour.$setValidity('invalidHour', false);
                return false;
            } else if ((departureDate === currentDate)
                && (parseInt($scope.params.RailTicketSearchSegments[0].DHour.Value, 10) === parseInt(CurrentTime[0], 10))
                && parseInt($scope.params.RailTicketSearchSegments[0].DMinutes.Value, 10) < parseInt(CurrentTime[1], 10)) {
                ctrl.railsSearch.OneWayDepartureMinutes.$error.invalidMinute = true;
                ctrl.railsSearch.$valid = false;
                ctrl.railsSearch.OneWayDepartureMinutes.$setValidity('invalidMinute', false);
                return false;
            }
            return true;
        }
    };

    $scope.validateReturnHoursAndMinutes = function(ctrl) {
        $timeout(() => {
            const departDate = Date.parse(moment($scope.params.RailTicketSearchSegments[0]._date, 'DD/MM/YYYY'));
            const returnDate = Date.parse(moment($scope.params.RailTicketSearchSegments[1]._date, 'DD/MM/YYYY'));

            if (returnDate && returnDate > departDate) {
                resetHourAndMinuteErrors(ctrl);
            }
        });
    };

    $scope.validateReturnDateTime = function(ctrl) { // eslint-disable-line
        if ($scope.params.isOpenReturn) {
            return true;
        }
        const ukDateTime = timeService.getUkTime();
        const departDate = Date.parse(moment($scope.params.RailTicketSearchSegments[0]._date, 'DD/MM/YYYY'));
        const departHours = $scope.params.RailTicketSearchSegments[0].DHour.Value;
        const departMinutes = $scope.params.RailTicketSearchSegments[0].DMinutes.Value;
        const returnDate = Date.parse(moment($scope.params.RailTicketSearchSegments[1]._date, 'DD/MM/YYYY'));
        ctrl.railsSearch.$valid = true;
        ctrl.railsSearch.date1.$error.dateMin = false;
        ctrl.railsSearch.RoundTripReturnHour.$error.invalidHour = false;
        ctrl.railsSearch.RoundTripReturnMinutes.$error.invalidMinute = false;
        ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', true);
        ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinute', true);
        if (!returnDate) {
            let rtnDate = ctrl.railsSearch.date1.$viewValue;
            rtnDate = Date.parse(moment(rtnDate, 'DD/MM/YYYY'));
            const day91FromToday = Date.parse(moment().add(91, 'd').toDate());
            if (rtnDate < (departDate || ukDateTime)) {
                ctrl.railsSearch.date1.$error.dateMin = true;
                ctrl.railsSearch.date1.$setValidity('dateMin', false);
                ctrl.railsSearch.$valid = false;
                return false;
            }
            if (rtnDate > day91FromToday) {
                ctrl.railsSearch.date1.$error.dateMax = true;
                ctrl.railsSearch.date1.$setValidity('dateMax', false);
                ctrl.railsSearch.$valid = false;
                return false;
            }
        } else if (returnDate === departDate) {
            if (parseInt($scope.params.RailTicketSearchSegments[1].RHour.Value, 10) < departHours) {
                ctrl.railsSearch.RoundTripReturnHour.$error.invalidHour = true;
                ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', false);
                ctrl.railsSearch.$valid = false;
                return false;
            } else if (parseInt($scope.params.RailTicketSearchSegments[1].RHour.Value, 10) === departHours
                && parseInt($scope.params.RailTicketSearchSegments[1].RMinutes.Value, 10) <= departMinutes) {
                ctrl.railsSearch.RoundTripReturnMinutes.$error.invalidMinute = true;
                ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinute', false);
                ctrl.railsSearch.$valid = false;
                return false;
            }
        }
        return true;
    };
    $scope.validateAll = function(ctrl, formType) { // eslint-disable-line
        if (ctrl.railsSearch.$valid) {
            if ($scope.validateDepartureDateTime(ctrl, formType)) {
                if ($scope.params.ReturnOrSingleJourney === 'R') {
                    if (!$scope.validateReturnDateTime(ctrl, formType)) {
                        return false;
                    }
                }
                if (($scope.params.ReturnOrSingleJourney === 'R')) {
                    if (!$scope.validateFromToStations(ctrl, '_address1')) {
                        return false;
                    }
                }
                if (($scope.params.ReturnOrSingleJourney === 'S')) {
                    if (!$scope.validateFromToStations(ctrl, '_address02')) {
                        return false;
                    }
                }

                if (!$scope.validateGoVia(ctrl)) {
                    ctrl.railsSearch.$valid = false;
                    return false;
                }

            }
            return true;
        }
    };

    $scope.params.Travelers.Adult = angular.copy(_.find($scope.options.adults, {value: _Adult.toString()}));
    $scope.params.RailTicketSearchSegments[0]._time
        = angular.copy($scope.params.RailTicketSearchSegments[0]._time) || angular.copy($scope.options.time0[0]);
    $scope.params.RailTicketSearchSegments[1]._time
        = angular.copy($scope.params.RailTicketSearchSegments[1]._time) || angular.copy($scope.options.time1[0]);
    $scope.params.RailTicketSearchSegments[2]._time
        = angular.copy($scope.params.RailTicketSearchSegments[2]._time) || angular.copy($scope.options.time2[0]);
    $scope.params.RailTicketSearchSegments[3]._time
        = angular.copy($scope.params.RailTicketSearchSegments[3]._time) || angular.copy($scope.options.time3[0]);
    delete $scope.params.SearchId;

    function getFrequentRails() {
        railsFactory.getFrequentRails().then(function(rails) {
            $scope.frequentRails = rails;
        });
    }

    function getRailCards() {
        if (!ukrailCardsService.railcardsApplied($scope.params.ukRailCards)) {
            $scope.params.ukRailCards = [{Description: 'Please select...', Code: ''}];
            $scope.params.ukRailCardNumbers = [{text: 1, value: 1}];
        }
        railsFactory.getStaticData()
            .then(({data: {RailCards}}) => $scope.options.railCards = _.filter(RailCards, (item) => item.CanBeSelected));
    }

    function getFrequentFlightView(rail) {
        const stationName = (rail.StationName)
            ? rail.StationName
            : getFrequentFlightAllLocationName();

        return _.template('{{DisplayString}}')({
            cityName: rail.CityName,
            countryCode: rail.CountryCode,
            stationName,
            stationCode: rail.StationCode,
            DisplayString: rail.DisplayString,
        });
    }

    function setSelectedFrequentRail(model, field, viewModel) {
        return function(rail) {
            if (viewModel) {
                viewModel.$setValidity('editable', true);
            }
            const name = rail.CityName + ', ' + rail.CountryCode;
            const station = rail.StationName ? rail.StationName : getFrequentFlightAllLocationName();
            const {StationCode: Code, DisplayString, IsCity} = rail;
            model[field] = {
                name,
                station,
                Code,
                DisplayString: `${DisplayString}`,
                IsCity,
            };
        };
    }

    function getFrequentFlightAllLocationName() {
        return $scope.isUkRail ? l10nService.localize('All Stations')
            : l10nService.localize('All Train Stations');
    }

    function setNextReturnTraintime() {
        if ($scope.params.RailTicketSearchSegments[1]._date) {
            const hours = parseInt($scope.params.RailTicketSearchSegments[1].RHour.Value, 10);
            const minutes = parseInt($scope.params.RailTicketSearchSegments[1].RMinutes.Value, 10);
            $scope.params.RailTicketSearchSegments[1].RMinutes = timeService.getSelectedMinutesOption(staticMinutesOptionsList, minutes);
            $scope.params.RailTicketSearchSegments[1].rHour = getHoursOption(hours, minutes);
        }
    }

    function setNextDepartureTraintime() {
        if ($scope.params.RailTicketSearchSegments[0]._date) {
            const hour = parseInt($scope.params.RailTicketSearchSegments[0].DHour.Value, 10);
            const minutes = parseInt($scope.params.RailTicketSearchSegments[0].DMinutes.Value, 10);
            $scope.params.RailTicketSearchSegments[0].DMinutes = angular.copy(timeService.getSelectedMinutesOption(staticMinutesOptionsList, minutes));
            $scope.params.RailTicketSearchSegments[0].DHour = getHoursOption(hour, minutes);
            return;
        }

        const ukdatetime = getCurrentUKDateTime();
        const ukTime = moment(ukdatetime).format('HH:mm');

        $scope.params.RailTicketSearchSegments[0]._date = moment(ukdatetime).format('DD-MM-YYYY');
        $scope.currentTime = ukTime;
        $scope.currentTimeArray = $scope.currentTime.split(':');

        $scope.params.RailTicketSearchSegments[0].DHour = angular.copy($scope.options.ukRailTimeHoursOptions[parseInt($scope.currentTimeArray[0], 10)]);
        if (!$scope.params.isOpenReturn) {
            $scope.params.RailTicketSearchSegments[1].RHour = angular.copy($scope.options.ukRailTimeHoursOptions[0]);
        }
        $scope.minuteNextTrain = parseInt($scope.currentTimeArray[1], 10);

        if ($scope.minuteNextTrain > 45) {
            $scope.params.RailTicketSearchSegments[0].DHour = angular.copy($scope.options.ukRailTimeHoursOptions[parseInt($scope.currentTimeArray[0], 10) + 1]);
            if (!$scope.params.isOpenReturn) {
                $scope.params.RailTicketSearchSegments[1].RHour = angular.copy($scope.options.ukRailTimeHoursOptions[0]);
            }
        }

        $scope.params.RailTicketSearchSegments[0].DMinutes = angular.copy(timeService.getSelectedMinutesOption(staticMinutesOptionsList, $scope.minuteNextTrain));

        if (!$scope.params.isOpenReturn) {
            $scope.params.RailTicketSearchSegments[1].RMinutes = angular.copy(staticMinutesOptionsList[0]);
        }
    }

    function getCurrentUKDateTime() {
        return calcTime(1);
    }

    function calcTime(offset) {
        const date = new Date();
        const utc = date.getTime() + (date.getTimezoneOffset() * 60000);
        return new Date(utc + (3600000 * offset));
    }

    /* setting the same date as of Departure for return date on de-selecting the OpenReturn option */
    $scope.setReturndate = function(ctrl) {
        if ($scope.params.isOpenReturn || angular.isUndefined($scope.params.RailTicketSearchSegments[1]._date)) {
            if ($scope.validateDepartureDateTime(this, 'roundtrip')) {
                ctrl.railsSearch.RoundTripReturnHour.$setValidity('invalidHour', true);
                ctrl.railsSearch.RoundTripReturnMinutes.$setValidity('invalidMinutes', true);
                ctrl.railsSearch.$valid = true;
            }
        }
    };
    $scope.validateGoVia = function(ctrl) { // eslint-disable-line
        if (!ctrl.railsSearch.$valid) {
            return ctrl.railsSearch.$valid;
        }
        if (ctrl.railsSearch._address3) {
            ctrl.railsSearch._address3.$error.selectGoViaStation = false;
            ctrl.railsSearch._address3.$error.invalidGoViaStation = false;
            ctrl.railsSearch._address3.$setValidity('selectGoViaStation', true);
            ctrl.railsSearch._address3.$setValidity('invalidGoViaStation', true);
            ctrl.railsSearch.$valid = true;
            if (angular.isDefined($scope.params.GoViaOrAvoid)) {
                if ($scope.params.GoViaOrAvoid.Value !== '') {
                    if ($scope.params.GoViaOrAvoidRailStation === null || angular.isUndefined($scope.params.GoViaOrAvoidRailStation.Code) || $scope.params.GoViaOrAvoidRailStation.Code === '') {
                        ctrl.railsSearch._address3.$error.selectGoViaStation = true;
                        ctrl.railsSearch.$valid = false;
                        ctrl.railsSearch._address3.$setValidity('selectGoViaStation', false);
                        return false;
                    } else if (angular.isDefined($scope.params.GoViaOrAvoidRailStation)) {
                        if ($scope.params.RailTicketSearchSegments[0]._departure.Code === $scope.params.GoViaOrAvoidRailStation.Code
                            || $scope.params.RailTicketSearchSegments[0]._arrival.Code === $scope.params.GoViaOrAvoidRailStation.Code) {
                            ctrl.railsSearch._address3.$error.invalidGoViaStation = true;
                            ctrl.railsSearch._address3.$setValidity('invalidGoViaStation', false);
                            ctrl.railsSearch.$valid = false;
                        }
                    }
                    if ($scope.params.GoViaOrAvoid.Text === 'None') {
                        $scope.params.GoViaOrAvoidRailStation = '';
                    }
                }
            }
        }
        return ctrl.railsSearch.$valid;
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/base/controllers/ukrail/railSearchFormBaseCtrl.js